import React from 'react';

export const stripBackgrounds = {
  'Men Fashion': '#ffffff',
  'Women Fashion': '#ffffff',
  'Kids Fashion': '#ffffff',
  default: '#ffffff',
};

const TOGGLES = [
  { label: 'MAN', value: 'Men Fashion' },
  { label: 'WOMAN', value: 'Women Fashion' },
  { label: 'KIDS', value: 'Kids Fashion' },
];

const CircularCategorySelector = ({ selectedCategory, onSelectCategory }) => {
  return (
    <div className="flex items-center justify-center gap-2 py-3 px-4 bg-white">
      {TOGGLES.map((t) => {
        const active = selectedCategory === t.value;
        return (
          <button
            key={t.value}
            onClick={() => onSelectCategory(t.value)}
            className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 ${
              active
                ? 'bg-black text-white'
                : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
            }`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
};

export default CircularCategorySelector;
